import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { mutations } from '@/store/modules/profile/mutations'
import { IProfileState, initialState } from '@/store/modules/profile/state'

export * from '@/store/modules/profile/state'

export const store: Module<IProfileState, RootState> = {
  state: initialState,
  mutations
}
